import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconSettings = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      fill={color}
      fillRule="evenodd"
      d="M14.928 4.577a1 1 0 0 0-.5-.866L8.5.29a1 1 0 0 0-1 0L1.572 3.71a1 1 0 0 0-.5.866v6.846a1 1 0 0 0 .5.866L7.5 15.71a1 1 0 0 0 1 0l5.928-3.422a1 1 0 0 0 .5-.866V4.577Zm-2 .578L8 2.309 3.072 5.155v5.69L8 13.691l4.928-2.846v-5.69ZM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm.707-3.707Q9 7.586 9 8q0 .415-.293.708Q8.414 9 8 9t-.707-.292Q7 8.415 7 8q0-.414.293-.707T8 7q.414 0 .707.293Z"
    />
  ),
})``;

export default IconSettings;
